import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/styles/index.scss'

// 导入性能监控和错误处理工具
// import PerformancePlugin from './utils/performance'

const app = createApp(App)

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用插件
app.use(ElementPlus)
app.use(router)
app.use(store)
// app.use(PerformancePlugin)

// 暴露Vue Router实例到window对象，以便在响应拦截器中使用
window.__VUE_ROUTER__ = router

// WebSocket fallback实现，处理WebSocket不可用的情况
if (typeof WebSocket === 'undefined') {
  console.log('⚠️  当前环境不支持WebSocket，使用fallback实现')
  window.WebSocket = function () {
    return {
      readyState: 3, // CLOSED
      close: function () {},
      send: function () {},
      onopen: null,
      onmessage: null,
      onerror: null,
      onclose: null
    }
  }
  window.WebSocket.CONNECTING = 0
  window.WebSocket.OPEN = 1
  window.WebSocket.CLOSING = 2
  window.WebSocket.CLOSED = 3
}

// 挂载应用
app.mount('#app')

// 开发环境性能提示
if (import.meta.env.DEV) {
  console.log('🚀 自助打印系统管理后台启动成功')
  console.log('🔧 开发模式：', import.meta.env.MODE)
}
